import {Utils} from "../../../../base/core";

/**
 * @inheritDoc
 */
class MapboxUtils extends Utils {
}

export default MapboxUtils;
